<template>
    <transition appear name="fade-transition">
        <span class="display__percentage">
            <app-tooltip :value="tooltipValue" :disabled="tooltipDisabled || displayValue === tooltipValue">
                {{ displayValue }}
            </app-tooltip>
        </span>
    </transition>
</template>

<script>
import Display from './Display';

export default {
    name: 'DisplayPercentage',
    extends: Display,
    computed: {
        displayValue() {
            if (this._.isNil(this.value) && this.fallback) {
                return this.fallback;
            }

            return this.toPercentage(this.value, this.optionsConfig, this.getOption('abbreviate'));
        },
        tooltipValue() {
            return this.toPercentage(this.value, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 9
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.display__percentage {
    min-width: 7rem;
}
</style>
